/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';

import '../../styles/process-card.scss';

export default function ProcessCard({ title, content, image, head }) {
  return (
    <div className="process-card-wrapper">
      <div className="img-wrapper">
        <img src={`/img/${image}`} alt="process card" />
      </div>
      <div className="card-styler">
        <h5>{head}</h5>
        <h3>{title}</h3>
        <div className="process-card-body" dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </div>
  );
}

ProcessCard.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  image: PropTypes.string,
  head: PropTypes.string
};

ProcessCard.defaultProps = {
  title: '',
  content: '',
  image: '',
  head: ''
};
